import styled from "styled-components";

export const AttachmentPreviewItem = styled.div`
  display: block;
  margin-bottom: 10px;
`;

export const RemoveButton = styled.button`
  margin-right: 10px;
`;
